import { RosterPositions } from "enums/rosterPositions";
import { UniformItemBottomTypes } from "enums/uniformItemBottomTypes";
import { UniformItemColors } from "enums/uniformItemColors";
import { UniformItemTopTypes } from "enums/uniformItemTopTypes";
import { UniformItemTypes } from "enums/uniformItemTypes";
import type { SportConfiguration } from "types/sportConfiguration";
import { defaultsConfig } from "./defaults";

const rosterPositions: Array<RosterPositions> = [
  RosterPositions.Center,
  RosterPositions.Forward,
  RosterPositions.ForwardCenter,
  RosterPositions.Guard,
  RosterPositions.GuardForward,
  RosterPositions.PowerForward,
  RosterPositions.PointGuard,
  RosterPositions.SmallForward,
  RosterPositions.ShootingGuard,
];

const uniforms: SportConfiguration["uniforms"] = {
  bottomOptions: [UniformItemBottomTypes.Shorts],
  items: [
    {
      titleIntlKey: "uniformModal.preview.regular",
      topType: [UniformItemTopTypes.Sleeveless],
      itemTypes: {
        [UniformItemTypes.Top]: [UniformItemColors.Primary],
        [UniformItemTypes.Bottom]: [UniformItemColors.Primary],
      },
    },
    {
      titleIntlKey: "uniformModal.preview.warmUp",
      topType: [UniformItemTopTypes.LongSleeve, UniformItemTopTypes.ShortSleeve],
      itemTypes: {
        [UniformItemTypes.WarmUpTop]: [UniformItemColors.Primary, UniformItemColors.Secondary],
      },
    },
  ],
};

export const basketballConfig: SportConfiguration = {
  ...defaultsConfig,
  rosterPositions,
  uniforms,
};
